export default "__VITE_ASSET__BlsTjsfp__"